import { LinkOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

export default function DocsButton(props) {
    const { t } = useTranslation();
    const { url, style } = props;
    return <Button icon={<LinkOutlined />} href={"https://docs.powershelluniversal.com/" + url} target="_blank" style={style}>{t('common.documentation')}</Button>
}